export enum TipoOperacionProductoCompuesto {
    REGISTRAR = "registrar",    
    DESCUENTO = "descuento",    
    INCIDENCIA ="incidencia",
    TRASPASO="traspaso"        
}
  